/* esm.sh - @radix-ui/react-switch@1.2.6 */
export * from "/*@radix-ui/react-switch@1.2.6/esnext/react-switch.mjs";
